"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var WrtUpstreamThinking_exports = {};
__export(WrtUpstreamThinking_exports, {
  WrtUpstreamThinking: () => WrtUpstreamThinking
});
module.exports = __toCommonJS(WrtUpstreamThinking_exports);
var import_topo_map = require("@cartographerio/topo-map");
var import_core = require("../../core/index.js");
const WrtUpstreamThinking = (0, import_core.mapSchemaWithDefaults)({
  mapId: (0, import_topo_map.unsafeMapId)("wrtUpstreamThinking"),
  title: "Upstream Thinking",
  layers: [
    (0, import_topo_map.pointLayer)({
      layerId: (0, import_topo_map.unsafeMapLayerId)("wrtUpstreamThinking"),
      title: "Upstream Thinking",
      source: (0, import_core.cartographerSourceWithDefaults)({
        layerId: (0, import_topo_map.unsafeMapLayerId)("wrtUpstreamThinking"),
        attribution: []
      }),
      defaultAttribute: "flow",
      defaultZOrder: "timestamp",
      attributes: [
        (0, import_topo_map.attributeGroup)({
          label: "Survey",
          attributes: [
            (0, import_topo_map.teamAttr)("teamId", "Team"),
            (0, import_topo_map.surveyAttr)("surveyId", "Survey"),
            (0, import_topo_map.surveyorAttr)(),
            (0, import_topo_map.attachmentAttr)("photographs", "Photographs"),
            (0, import_topo_map.timestampAttr)({
              attributeId: "timestamp",
              label: "Date/Time",
              buckets: "auto"
            })
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "Data",
          attributes: [
            (0, import_topo_map.numberAttr)({
              attributeId: "flow",
              label: "Estimated flow",
              unit: "m3/s",
              buckets: "auto"
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "temperature",
              label: "Temperature",
              unit: "C",
              buckets: [
                (0, import_topo_map.rangeBucket)(null, 4, import_topo_map.marker.fromColor("#2e3090")),
                (0, import_topo_map.rangeBucket)(4, 8, import_topo_map.marker.fromColor("#0865b1")),
                (0, import_topo_map.rangeBucket)(8, 12, import_topo_map.marker.fromColor("#1094d8")),
                (0, import_topo_map.rangeBucket)(12, 16, import_topo_map.marker.fromColor("#15a9c2")),
                (0, import_topo_map.rangeBucket)(16, 20, import_topo_map.marker.fromColor("#ea8133")),
                (0, import_topo_map.rangeBucket)(20, null, import_topo_map.marker.fromColor("#be2432"))
              ]
            }),
            (0, import_topo_map.numberAttr)({ attributeId: "ph", label: "pH", buckets: "auto" }),
            (0, import_topo_map.numberAttr)({
              attributeId: "electricalConductivity",
              label: "Electrical conductivity",
              unit: "\xB5s/cm",
              buckets: "auto"
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "turbidity",
              label: "Turbidity",
              unit: "FAU",
              buckets: "auto"
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "suspendedSediment",
              label: "Suspended sediment",
              unit: "mg/l",
              buckets: "auto"
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "color",
              label: "Colour",
              unit: "Hazen",
              buckets: "auto"
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "totalDissolvedSolids",
              label: "Total dissolved solids",
              unit: "mg/l",
              buckets: [
                (0, import_topo_map.rangeBucket)(null, 50, import_topo_map.marker.fromColor("hsl(120, 80%, 70%)")),
                (0, import_topo_map.rangeBucket)(50, 200, import_topo_map.marker.fromColor("hsl(120, 80%, 58%)")),
                (0, import_topo_map.rangeBucket)(200, 350, import_topo_map.marker.fromColor("hsl(120, 80%, 48%)")),
                (0, import_topo_map.rangeBucket)(350, 500, import_topo_map.marker.fromColor("hsl(120, 80%, 40%)")),
                (0, import_topo_map.rangeBucket)(500, 650, import_topo_map.marker.fromColor("hsl(120, 80%, 32%)")),
                (0, import_topo_map.rangeBucket)(650, 800, import_topo_map.marker.fromColor("hsl(120, 80%, 22%)")),
                (0, import_topo_map.rangeBucket)(800, null, import_topo_map.marker.fromColor("hsl(120, 80%, 10%)"))
              ]
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "tryptophan",
              label: "Tryptophan",
              unit: "counts",
              buckets: "auto"
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "phosphate",
              label: "Phosphates",
              unit: "mg/l",
              buckets: "auto"
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "dissolvedOxygenSaturation",
              label: "Dissolved oxygen saturation",
              unit: "%",
              buckets: "auto"
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "dissolvedOxygenConcentration",
              label: "Dissolved oxygen concentration",
              unit: "mg/l",
              buckets: "auto"
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "coloredDissolvedOrganicMatter",
              label: "Colored dissolved organic matter",
              unit: "counts",
              buckets: "auto"
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "opticalBrighteningAgents",
              label: "Optical brightening agents",
              unit: "counts",
              buckets: "auto"
            })
          ]
        })
      ]
    })
  ]
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  WrtUpstreamThinking
});
//# sourceMappingURL=WrtUpstreamThinking.js.map
